import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
@Injectable({
  providedIn: 'root'
})
export class SuppliersService {
  public Data = new BehaviorSubject(null)
  constructor(private _HttpClient:HttpClient) { }
  GetSuppliersPaged(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/Supplier/GetPaged`,data);
  }
  GetSuppliersById(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/Supplier/GetById?Id=${id}`);
  }
}
